import React from "react";

import RegistrationForm from "../components/users/registrationForm/RegistrationForm";

const Registration = () => {
  return (
    <div className="regiter-page">
      <RegistrationForm />
    </div>
  );
};

export default Registration;
